import { brandColorOf } from './brand-color';

// Page de connexion brandée (#37, #38) : `/login/merchant?merchant=<id>` affiche le logo, le nom et la
// couleur du marchand, lus sans jeton sur `GET /api/merchants/:id/branding`. Sans paramètre, ou si la
// marque est introuvable, la page reste la page générique.
export type LoginBranding = { name: string; logoUrl: string | null; brandColor: string | null };

/** URL de connexion brandée d'un marchand, à copier depuis sa fiche super admin. */
export function brandedLoginUrl(origin: string, merchantId: string): string {
  return `${origin}/login/merchant?merchant=${encodeURIComponent(merchantId)}`;
}

/** Id du marchand demandé par l'URL de la page de connexion (`?merchant=`), ou `null`. */
export function brandingMerchantId(search: string): string | null {
  const id = new URLSearchParams(search).get('merchant')?.trim();
  return id ? id : null;
}

/**
 * Marque lisible d'une réponse de `GET /api/merchants/:id/branding`, ou `null` (corps inattendu : page
 * générique). Une couleur invalide ou un logo vide n'empêchent pas d'afficher le nom.
 */
export function loginBrandingOf(body: unknown): LoginBranding | null {
  if (!body || typeof body !== 'object') return null;
  const { name, logoUrl, brandColor } = body as Record<string, unknown>;
  if (typeof name !== 'string' || !name.trim()) return null;
  return {
    name: name.trim(),
    logoUrl: typeof logoUrl === 'string' && logoUrl.trim() ? logoUrl.trim() : null,
    brandColor: brandColorOf(brandColor),
  };
}
